import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'

import { Container } from '@mui/material'

import { getToken, checkToken, getPermission } from '../auth/ApiAuth';
import Footer from "../components/Footer";
import Box from '@mui/material/Box';
import { useSelector, useDispatch, connect } from 'react-redux';
import { getTypeCounter, setCounterLoading } from '../redux/actions/lessons'
import { setEditedTeacher, editTeacher, resetEditedTeacher, deleteTeacher, updateTeacher, createTeacher, setTeachers } from '../redux/actions/teacher'
import { getAllSettings } from '../redux/actions/settings';

import UserListStats from '../components/UserListStats';
import Navbar from '../components/Navbar';
import DialogEditTeacher from '../components/DialogEditTeacher'
import ConfirmDialog from '../components/DialogConfirmDelete';
import { getTeacherIds, getTeachersByIds } from '../api/users'

import moment from 'moment';

const Instructors = ({
  editedTeacher,
  editTeacher
}) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const [teacherDialogOpen, setTeacherDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deletedTeacherId, setDeletedTeacherId] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [allIds, setAllIds] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const teacherCounters = useSelector(state => state.lesson.typeCounter.counter)
  const teachers = useSelector(state => state.teacher)

  useEffect(() => {
    const startOfMonth = moment().startOf('month').format('YYYY-MM-DD HH:mm');
    const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD HH:mm');

    dispatch(getAllSettings());
    dispatch(setCounterLoading(false));
    dispatch(getTypeCounter('teacher', startOfMonth, endOfMonth));

    ;(async () => {
      try {
        const idsResp = await getTeacherIds({ is_active: true });
        const ids = Array.isArray(idsResp?.ids) ? idsResp.ids : [];
        setAllIds(ids);
        setRowCount(ids.length);
        await fetchPage(0, rowsPerPage, ids);
      } catch (e) {
        console.log(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  async function fetchPage(newPage, newRowsPerPage, ids = allIds) {
    if (!Array.isArray(ids)) return;
    let sliceIds;
    if (newRowsPerPage === -1) {
      sliceIds = ids; // fetch all
    } else {
      const start = newPage * newRowsPerPage;
      const end = start + newRowsPerPage;
      sliceIds = ids.slice(start, end);
    }
    const resp = await getTeachersByIds(sliceIds);
    const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : []);
    dispatch(setTeachers(list));
  }

  const handleServerPageChange = async (newPage) => {
    setPage(newPage);
    await fetchPage(newPage, rowsPerPage);
  };

  const handleServerRowsPerPageChange = async (value) => {
    setRowsPerPage(value);
    setPage(0);
    await fetchPage(0, value);
  };

  if (checkToken(getToken()) || getPermission('student') || getPermission('teacher')) {
    history.push("/Login");
  }

  const handleSubmitTeacher = async (RegData) => {
    if (editedTeacher.isEdited()) {
      await dispatch(updateTeacher(RegData, editedTeacher.pk))
    } else {
      await dispatch(createTeacher(RegData))
    }
    setTeacherDialogOpen(false)
    await reloadIdsAndPage(0, rowsPerPage);
  }
  const handleEditTeacherClick = (teacher) => {
    dispatch(setEditedTeacher(teacher))
    setTeacherDialogOpen(true)
  }
  const handleAddTeacherClick = () => {
    setTeacherDialogOpen(true);
  }
  const handleTeacherDialogClose = () => {
    dispatch(resetEditedTeacher())
    setTeacherDialogOpen(false)
  }

  const handleDeleteTeacherClick = (teacher) => {
    setDeletedTeacherId(teacher.pk)
    setConfirmDialogOpen(true)
  }
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false)
  }
  const handleConfirmDeleteTeacher = async () => {
    await dispatch(deleteTeacher(deletedTeacherId));
    setConfirmDialogOpen(false);
    setDeletedTeacherId('');
    await reloadIdsAndPage(page, rowsPerPage);
  }
  
  const reloadIdsAndPage = async (desiredPage = page, desiredRowsPerPage = rowsPerPage) => {
    try {
      const idsResp = await getTeacherIds({ is_active: true });
      const ids = Array.isArray(idsResp?.ids) ? idsResp.ids : [];
      setAllIds(ids);
      const newCount = ids.length;
      setRowCount(newCount);
      const maxPage = desiredRowsPerPage > 0 ? Math.max(0, Math.ceil(newCount / desiredRowsPerPage) - 1) : 0;
      const safePage = Math.min(desiredPage, maxPage);
      setPage(safePage);
      await fetchPage(safePage, desiredRowsPerPage, ids);
    } catch (e) {
      console.log(e);
    }
  };
  const confirmContentText = `Usunięcie przeniesie instruktora do archiwum, a jego konto zostanie dezaktywowane.
  Lekcje instruktora zostaną zachowane, a konto można później przywrócić z archiwum.
  Czy na pewno chcesz usunąć tego instruktora?`;
  return (
    <Box>
      <Container component="main" maxWidth="lg">
        <Navbar />

        <DialogEditTeacher
          open={teacherDialogOpen}
          editedTeacher={editedTeacher}
          onChange={editTeacher}
          onClose={handleTeacherDialogClose}
          onSubmit={handleSubmitTeacher}

        />
        <ConfirmDialog
          open={confirmDialogOpen}
          title="Usuwanie Konta instruktora"
          contentText={confirmContentText}
          onClose={handleConfirmDialogClose}
          onConfirm={handleConfirmDeleteTeacher}
        />
        <UserListStats
          users={teachers.TeacherList}
          counters={teacherCounters}
          serverPagination
          page={page}
          rowsPerPage={rowsPerPage}
          rowCount={rowCount}
          onServerPageChange={handleServerPageChange}
          onServerRowsPerPageChange={handleServerRowsPerPageChange}
          isAddable={true}
          onAddUser={handleAddTeacherClick}
          onEditUser={handleEditTeacherClick}
          onDeleteUser={handleDeleteTeacherClick}
          isArchive={false}
          isActiveField
          archivePath="/ArchiveInstructors"
          activePath="/instructors"
          archiveTooltip="Archiwum instruktorów"
          activeTooltip="Aktywni instruktorzy"
          addTooltip="Tworzenie nowego instruktora"
          searchTooltip="Wyszukaj instruktora"
          addableUsers
          editableUsers
          overallLessonsField
        />
      </Container>
      <Footer/>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  editedTeacher: state.teacher.editedTeacher
})
const mapDispatchToProps = (dispatch) => ({
  editTeacher: (editedTeacherData) => dispatch(editTeacher(editedTeacherData))
})

export default connect(mapStateToProps, mapDispatchToProps)(Instructors);
